import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles(() => {
  return {
    StatusInline: {
      display: 'inline-flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    text: {
      color: '#FFF',
      lineHeight: '24px',
    },
    smallText: {
      fontSize: 12,
      fontWeight: 500,
    },
    StatusIcon: {
      width: 24,
      height: 20,
      marginRight: 8,
    },
  }
})
